<template lang="pug">
div
  SpeakWithUs
</template>

<script>
import SpeakWithUs from '../components/contact/SpeakWithUs'

export default {
  name: 'Enterprise',
  components: {
    SpeakWithUs
  }
}
</script>

<style lang="sass"></style>
